<div class="relative p-4 w-full h-full flex flex-col justify-between bg-white rounded-2xl">
    <div class="flex justify-between mb-3 relative w-full">
        <h4 class="mb-3 text-title font-normal mt-6"><span>{{'summary_chart.collected_amount' | translate}} </span><span class="fonts-bold">{{formatAmount(moneyCollected, 'XAF')}}</span></h4>
        <p class="text-sm absolute right-0 font-bold">{{'summary_chart.frequency_month' | translate}}</p>
    </div>
    <figure class="h-full w-full flex-1 relative" #canvas>&nbsp;</figure>
</div>
